import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

export const useSkipLinkReferer = (ref: React.RefObject<HTMLElement | null> | undefined) => {
  const [isVisible, setIsVisible] = useState(false);
  const location = useLocation();

  const checkVisibility = () => setIsVisible(!!ref?.current)

  useEffect(() => {

    checkVisibility();

    const observer = new MutationObserver(checkVisibility);
    if (ref?.current) {
      observer.observe(ref.current.parentNode as Node, {
        childList: true,
        subtree: true,
      });
    }

    window.addEventListener("resize", checkVisibility);

    return () => {
      observer.disconnect();
      window.removeEventListener("resize", checkVisibility);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ref, location.pathname]);

  return isVisible;
};
